var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content content--idea-form"},[_vm._m(0),_c('MyHeader',{attrs:{"breadcrumbItems":[

      {
        name: 'Ideaboard',
        path: ("/" + (_vm.$route.params.companySlug) + "/ideas")
      },
      {
        name: 'Add Idea',
        path: _vm.$route.path
      } ]}}),_vm._m(1),_c('div',{staticClass:"container main-content"},[_c('IdeaForm')],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-img"},[_c('img',{attrs:{"src":require("../../assets/images/hero-newidea.jpg")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"content-header"},[_c('h1',[_vm._v("Add new idea")])])}]

export { render, staticRenderFns }